import { type App, reactive, readonly } from 'vue';

// Import the global options.
import { preconJobsOptionsInjectionKey } from './symbols';
import {
    type PreconJobsGlobalOptions,
    normalizePreconJobsOptions,
} from './options';

// Export the
export type { PreconJobsGlobalOptions };

export { useJobTitle } from './composables/useJobTitle';
import './styles/animations.scss';

// Export the helpers that you want to use outside of this library.
// export * from './helpers/preconJobsTitle';
export { default as JobCard } from './components/JobCard.vue';
export { default as JobStateIcon } from './components/JobStateIcon.vue';
export { default as JobStateBadge } from './components/JobStateBadge.vue';
export { default as JobStateButton } from './components/JobStateButton.vue';

// Export the composables that you want to use outside of this library.
// export * from './composables/usePreconJobs';

// Import/Export the components that you want to use outside of this library.
// import { default as PreconJobsTitle } from './components/PreconJobsTitle.vue';
// export { PreconJobsTitle };

// The definition of the plugin that installs the
export default {
    install(app: App, options?: PreconJobsGlobalOptions) {
        /// NORMALIZE THE OPTIONS
        const normalizedOptions = reactive(
            normalizePreconJobsOptions(options ?? {})
        );

        /// INJECT THE OPTIONS
        // This ensures that the options are available to the components in this library.
        app.provide(preconJobsOptionsInjectionKey, readonly(normalizedOptions));

        /// GLOBAL COMPONENT BINDINGS
        // Use this to register the components that you use almost everywhere in the application.
        // WARNING! Do not register large components like this, as it introduces a significant overhead at the application startup.
        // app.component('PreconJobsTitle', PreconJobsTitle);

        // TODO: Implement the installation of the plugin.
    },
};
